import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data.range;

const getRangeFrom = createSelector(getState, (range) => range.start_from);
const getRangeTo = createSelector(getState, (range) => range.end_on);

const getRange = createSelector(getState, (range) => range);

export default {
  getRangeFrom,
  getRangeTo,
  getRange,
};
